<script setup lang="ts">
import type { PropType } from 'vue';

// PROPS
defineProps({
    appliedFilters: { type: Array as PropType<AppliedFilter[]>, required: true },
});
</script>

<template>
    <div v-if="appliedFilters.length" class="flex flex-wrap gap-1 p-4">
        <SlpAppliedFilterBadges :applied-filters="appliedFilters" />
    </div>
</template>
